/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum OrderFieldName {
  FIRSTNAME = 'firstname',
  LASTNAME = 'lastname',
  EMAIL = 'email',
  PHONE = 'phone',
  PERSONS = 'persons',
  DATE = 'date',
  TIME = 'time',
  PRICE = 'price',
  DURATION = 'duration',
  CUSTOM_DETAILS = 'custom_details',
  COMMENT = 'comment',
  EVENT_ID = 'event_id',
  ORDER_PAGE_ID = 'order_page_id',
  EMPLOYEE_IDS = 'employee_ids',
}
